import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import Reference from '@/fhirworks/types/Reference';

export default class IdentityVerification extends BackboneElement {
    static __className = 'IdentityVerification';

    __objectStructure = {
        // nameAndDobStated | photoMatch | wristband | governmentPhotoId | knownToMe | other
        method: String,
        // The method in the nurse's own words. Required when method is 'other', absent otherwise.
        detail: String,
        verifiedAt: String,
        verifiedBy: Reference,
    };

    constructor(constructJson, className = 'IdentityVerification') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
